export const defaultDesignerConfig = {
  showError: true,
  showDisplayCondition: true,
  // 默认隐藏英文id
  UcdToolbarBreadCrumbHideCompId: true,
  // 隐藏触发器工具菜单
  hideTriggersToolbarWidget: false,
  // 左侧面板切换tab时清空输入框
  clearSearchInputWhenSwitchLeftPanel: true,
  // 属性面板reset按钮 和齿轮按钮的tooltip隐藏
  hidePropPanelTooltip: false,
  // 侧面板折叠状态纪录到localstorage
  saveAsideExpandState: true,
  /** 绑定数据时，自动更新表单项标题 */
  formItemAutoSyncTitle: false
};